import { parsePhoneNumber } from "awesome-phonenumber";

export const formatPhoneNumber = (value: string) => {
    const ps = parsePhoneNumber(value, { regionCode: "US" });
    return ps?.number?.national ?? value;
};
